import { type Dispatch, type FC, type SetStateAction } from 'react';
import cn from 'classnames';

import { Button } from '@/components/ui/Button/Button';

import css from './styles.module.scss';

interface NavigationProps {
  className?: string;
  length: number;
  activeSlide: number;
  setActiveSlide: Dispatch<SetStateAction<number>>;
}

const Navigation: FC<NavigationProps> = ({
  length,
  className,
  activeSlide,
  setActiveSlide,
}) => {
  const toSlide = (index: number): void => {
    if (activeSlide !== index) {
      setActiveSlide(index);
    }
  };

  return (
    <nav className={cn(css.nav, className)}>
      {Array.from({ length }).map((_, index) => (
        <Button
          onClick={() => toSlide(index)}
          key={`slide-${index}`}
          className="flex-1 flex items-end py-3"
          variant="transparent"
        >
          <div
            className={cn(
              'w-full h-[4px]',
              activeSlide === index ? 'bg-white/40' : 'bg-white/10',
              index === 0 && 'rounded-l-[4px]',
              index === length - 1 && 'rounded-r-[4px]',
            )}
          ></div>
        </Button>
      ))}
    </nav>
  );
};

export { Navigation };
